import { ExtensionInstance, Route } from '../type'
import { handleError } from '../utils/fetchUtils'

export class RouteApi {
    baseURL = '/services/plugin-smart-mobility-home-page'

    list = (extensionUuid: string): Promise<Route[]> => {
        const options: any = { method: 'GET' }

        return fetch(`${this.baseURL}/routes/${extensionUuid}`, options).then(async response => {
            await handleError(response)

            return response.json()
        })
    }

    post = (extensionUuid: string, body: ExtensionInstance): Promise<void> => {
        const options: any = {
            method: 'POST',
            body: JSON.stringify(body),
            headers: { 'Content-Type': 'application/json' }
        }

        return fetch(`${this.baseURL}/routes/${extensionUuid}`, options).then(async response => {
            return await handleError(response)
        })
    }

    getAll(): Promise<{ [key: string]: ExtensionInstance }[]> {
        return fetch(`${this.baseURL}/routes`).then(async response => {
            await handleError(response)

            return response.json()
        })
    }
}
